<template>
        <ranking-list
      title="Top analysts"
      :items="items"
      :active-id="data.id"
      :processed="true"
      :settings="{
        title: 'Top analysts',
        path: 'analysts',
        colWidth: 12,
        cols: ['name', 'views'],

        type: 'infinity-rank',
      }"
      :client-width="clientWidth"
    />
    </template>

<script>
import axios from '@/axios'
import {createHttpQuery} from '@/helpers'
import AnalyticsMixin from '@/analytics/mixins/AnalyticsMixin'
import TimeframeMixin from '@/analytics/mixins/TimeframeMixin'
import RankingList from '@/components/RankingList'

export default {
  name: 'TopArticlesList',
  mixins: [AnalyticsMixin, TimeframeMixin],
  components: {
    RankingList,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      items: [],
}
  },
  mounted() {
    this.changed()
  },
  watch: {
    timeframe() {
      this.changed()
    }
  },
  methods: {

  async changed() {
    const items = [];
    // You can update items fetching logic as needed
    const r = this.data.topAnalystsByTimeframe[this.timeframe];
    const ids = r.map(item => item.id);
          const params = createHttpQuery({analyst_ids: ids});
    const {data: analysts} = await axios.get('/analysts', {params});
    console.log(analysts)
    for (const [i,item] of Object.entries(r)) {
      items.push({ ...item, name: analysts.data.find(c => c.id === item.id)?.name || item.id })
    }
    this.items = items
    console.log("ITEMS:",this.items)
    this.clientWidth = window.innerWidth
  },
}
}
</script>
